<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { _ } from 'svelte-i18n';
  import { AppState, ToastQueue } from '../../etc/stores';
  import { copyTextToClipboard } from '../../etc/utils';
  import { replaceVariables } from '../../i18n';
  import Check from '../icons/Check.svelte';
  import Copy from '../icons/Copy.svelte';
  import Heading from '../typography/Heading.svelte';

  export let code: string = '';
  export let disabled: boolean = false;

  const { primary200 } = $AppState.theme.colors;
  const dispatch = createEventDispatcher();

  let copied = false;

  const t = (text: string, values?: any) => {
    return replaceVariables($_(`convert_coins.${text}`), values);
  };

  const onCopy = () => {
    copied = true;

    copyTextToClipboard(code);
    ToastQueue.add({
      title: t('copied_success.title'),
      message: t('copied_success.message'),
      type: 'success',
      duration: 1500
    });

    dispatch('copy');
    setTimeout(() => {
      copied = false;
    }, 5000);
  };
</script>

<div
  class="twism-copy-code {$$props.class || ''}"
  class:--disabled={disabled}
  role="button"
  on:click={onCopy}
> 
  <div class="twism-copy-code__content">
    <slot>
      <Heading class="twism-copy-code__text" type="h3" color={primary200}>
        {code}
      </Heading>
    </slot>
    {#if copied}
      <Check size={20} stroke={primary200} />
    {:else}
      <Copy color={primary200} />
    {/if}
  </div>
  <slot name="bottom-component" />
</div>

<style lang="scss">
  :global(.twism-copy-code__text) {
    flex-grow: 1;
    margin-left: 16px !important;
    text-align: center !important;
  }

  .twism-copy-code {
    padding: 16px;
    background: var(--twism-theme-primary600);
    border: 1px dashed var(--twism-theme-primary400);
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    position: relative;

    :global(> div:empty) {
      display: none;
    }

    &__content {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      > :global(svg) {
        flex-shrink: 0;
        position: absolute;
        top: 16px;
        right: 16px;
      }
    }

    &.--disabled {
      pointer-events: none;
      opacity: 0.30;
    }
  }
</style>
